import script from "./MessageContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageContainer.vue?vue&type=script&setup=true&lang=ts"

import "./MessageContainer.vue?vue&type=style&index=0&id=3e4fbddb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4fbddb"]])

export default __exports__